import { Reward, RewardTitle } from '../../../reward/reward';

/**
 * Reward DTO for put and post requests
 */
export class RewardRequestDTO implements Reward {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    // Reward Interface  //
    public cost: number,
    public imgSource: string | null,
    public discount: number,
    public rewardType: string,
    public businessLevelIds: number[],
    public rewardTitles: RewardTitle[] | null,
    public startDate: Date,
    public endDate: Date | null,
    public redemptionLimit: number,
    public extensionPeriod: number,
    public relatedWithProduct: boolean,
    public rewardFamilyIds: number[],
    public rewardCode: string,
    public rewardExceptions: number[],
    public productId: number
  ) {}

  /**
   * formats the outbound rewardTitle array
   * @param {string} name
   * @param {string} namePt
   * @param {string} nameEs
   * @return {RewardTitle[]}
   */
  static formatRewardTitles(
    name: string,
    namePt: string,
    nameEs: string
  ): RewardTitle[] {
    return [
      {
        language: 'en',
        name: name,
      },
      {
        language: 'pt',
        name: namePt,
      },
      {
        language: 'es',
        name: nameEs,
      },
    ] as RewardTitle[];
  }
}
